var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemTable',{attrs:{"title":"介護保険","authDiv":_vm.authDiv,"headers":_vm.careHeaders,"items":_vm.items,"item_class":_vm.careItemsRowBackground},on:{"makenew":_vm.careCreate,"repair":_vm.careRepair,"copy":_vm.careCopy}})}
var staticRenderFns = []

export { render, staticRenderFns }